import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-offer-not-found',
  templateUrl: './offer-not-found.component.html',
  styleUrls: ['./offer-not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OfferNotFoundComponent {}
